import React, { Component } from 'react'

export class EmailAlertSetup extends Component {
  constructor(props) {
    super(props)
    this.state = { 
      data: props.data, 
      callFunc: props.callFunc
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data !== prevState.data) {
      return { data: nextProps.data, callFunc: nextProps.callFunc };
    }
    else return null; // Triggers no change in the state
  }

  componentDidUpdate() {
    this.bindControls()
  }

  componentDidMount() {
    this.bindControls()
  }



  bindControls = () => {
    if(this.props.parentComponent !== 'search')
    {
      this.cbDailyWrapUpPrimaryFilter.value = this.state.data.dailyWrapUpPrimaryFilter
      this.cbDailyWrapUpSecondaryFilter.value = this.state.data.dailyWrapUpSecondaryFilter
    }

    this.cbInstantAlert.checked = this.state.data.instantAlert
    this.cbDailyWrapUpAlert.checked = this.state.data.dailyWrapUpAlert
    this.dailyWrapUpTime.value = this.state.data.dailyWrapUpAlertTime
      }

  onChange = () => {
    let instantAlert = this.cbInstantAlert.checked
    let dailyWrapUpAlert = this.cbDailyWrapUpAlert.checked
    let dailyWrapUpAlertTime = this.dailyWrapUpTime.value
    let dailyWrapUpPrimaryFilter = this.props.parentComponent !== 'search' ? this.cbDailyWrapUpPrimaryFilter.value : 0
    let dailyWrapUpSecondaryFilter = this.props.parentComponent !== 'search' ? this.cbDailyWrapUpSecondaryFilter.value : 0
    if(this.props.parentComponent !== 'search' && dailyWrapUpPrimaryFilter == 1 && dailyWrapUpSecondaryFilter == 3||dailyWrapUpPrimaryFilter == 2 && dailyWrapUpSecondaryFilter == 4||dailyWrapUpPrimaryFilter == 3 && dailyWrapUpSecondaryFilter == 5)
    {
      dailyWrapUpSecondaryFilter = 2;
    }

    this.setState({
      data: {
        instantAlert: instantAlert,
        dailyWrapUpAlert: dailyWrapUpAlert,
        dailyWrapUpAlertTime: dailyWrapUpAlertTime,
        dailyWrapUpPrimaryFilter: dailyWrapUpPrimaryFilter,
        dailyWrapUpSecondaryFilter: dailyWrapUpSecondaryFilter
      }
    })
  
    this.state.callFunc(instantAlert, dailyWrapUpAlert, dailyWrapUpAlertTime, dailyWrapUpPrimaryFilter, dailyWrapUpSecondaryFilter)
  }

  render() {
    let primaryValue = this.state.data.dailyWrapUpPrimaryFilter;
    return (
      <div id='emailAlertSetup'>
        <h3>Select your email alerts</h3>
        {this.props.parentComponent === 'search' ?
          <p>Switch email alerts on or off for this saved search.<br /></p>
          :
          <p>Select the email alerts you want to receive for this content set.<br /></p>
        }
        <div className='options_wrapper'>
          <div className='checkbox'>
            <input id='cbInstantAlert'
              ref={input => {
                this.cbInstantAlert = input;
              }}
              name='cbInstantAlert' type='checkbox' onChange={this.onChange}
              defaultValue={this.state.instantAlert} />
            <label htmlFor='cbInstantAlert'>Instant alert</label>
          </div>
          <div className='options_text'>One email containing the full text of a single article the moment it is published.</div>
        </div>
        <div className='options_wrapper'>
          <div className='checkbox'>
            <input id='cbDailyWrapUpAlert'
              ref={input => {
                this.cbDailyWrapUpAlert = input;
              }}
              name='cbDailyWrapUpAlert' type='checkbox' onChange={this.onChange} />
            <label htmlFor='cbDailyWrapUpAlert'>Daily Wrap-up alert</label>
              <span className='info-icon tooltip bottom' aria-label='After you have switched off a Daily Wrap-up you may still receive one more alert before you stop receiving them.'></span>
          </div>
         
          <div className='options_text'>
          {this.props.parentComponent === 'search' ?
            'A daily email containing headlines and summaries of all articles published that match your search, sent at the time you choose below.'
            :
            'A daily email containing headlines and summary of all articles published.  Select from the below options to personalize the delivery time and how articles should be grouped within the email.'
            }
          </div>
        </div>
        <div id='divDailyWrapUpTime' className='options_text' style={this.state.data.dailyWrapUpAlert ? null : { display: 'none' }}>
          <strong>Set your delivery time (GMT)<span className='mandatory'>*</span></strong><br />
          <select id='dailyWrapUpTime' className={`${this.props.data.errors["dailyAlertTime"] ? 'error-input' : ''}`}
            ref={input => {
              this.dailyWrapUpTime = input;
            }}
            onChange={this.onChange}>
            <option value='-1'>Select time</option>
            <option value='00:00'>00:00 (GMT)</option>
            <option value='01:00'>01:00 (GMT)</option>
            <option value='02:00'>02:00 (GMT)</option>
            <option value='03:00'>03:00 (GMT)</option>
            <option value='04:00'>04:00 (GMT)</option>
            <option value='05:00'>05:00 (GMT)</option>
            <option value='06:00'>06:00 (GMT)</option>
            <option value='07:00'>07:00 (GMT)</option>
            <option value='08:00'>08:00 (GMT)</option>
            <option value='09:00'>09:00 (GMT)</option>
            <option value='10:00'>10:00 (GMT)</option>
            <option value='11:00'>11:00 (GMT)</option>
            <option value='12:00'>12:00 (GMT)</option>
            <option value='13:00'>13:00 (GMT)</option>
            <option value='14:00'>14:00 (GMT)</option>
            <option value='15:00'>15:00 (GMT)</option>
            <option value='16:00'>16:00 (GMT)</option>
            <option value='17:00'>17:00 (GMT)</option>
            <option value='18:00'>18:00 (GMT)</option>
            <option value='19:00'>19:00 (GMT)</option>
            <option value='20:00'>20:00 (GMT)</option>
            <option value='21:00'>21:00 (GMT)</option>
            <option value='22:00'>22:00 (GMT)</option>
            <option value='23:00'>23:00 (GMT)</option>
          </select>
        </div>
        
        { this.props.parentComponent !== 'search' &&
        <div id='divDailyWrapUpPrimaryFilter' className='options_text' style={this.state.data.dailyWrapUpAlert ? null : { display: 'none' }}>
          <strong>Group articles under this primary sub-heading<span className='mandatory'>*</span></strong><br />
          <select id='dailyWrapUpPrimaryFilter'
            ref={input => {
              this.cbDailyWrapUpPrimaryFilter = input;
            }}
            onChange={this.onChange}>
            <option value='1'>Area of Interest</option>
            <option value='2'>Industry</option>
            <option value='3'>Geography</option>
          </select>
        </div>
        }
        { this.props.parentComponent !== 'search' &&
        <div id='divDailyWrapUpSecondaryFilter' className='options_text' style={this.state.data.dailyWrapUpAlert ? null : { display: 'none' }}>
          <strong>Then group articles under this secondary sub-heading<span className='mandatory'>*</span></strong><br />
          <select id='dailyWrapUpSecondaryFilter'
            ref={input => {
              this.cbDailyWrapUpSecondaryFilter = input;
            }}
            onChange={this.onChange}>
            <option value='1'>None</option>
            <option value='2'>Content Type</option>
            {primaryValue != 1 && <option value='3'>Area of Interest</option>}
            {primaryValue != 2 && <option value='4'>Industry</option>}
            {primaryValue != 3 && <option value='5'>Geography</option>}
          </select>
        </div>
        }
      </div>
    )
  }
}

export default EmailAlertSetup
